import * as o from "react";
import n from "../lib/IconBase.es.js";
import c from "../defs/SortAscending.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: c }));
e.displayName = "SortAscendingIcon";
const i = e;
export {
  i as SortAscending,
  e as SortAscendingIcon
};
